import React, { useEffect } from 'react';
import { useState } from 'react';
import { Button, Grid, useMediaQuery } from '@mui/material';
import { Location } from 'history';
import { ReactElement } from 'react';
import { StaticContext } from 'react-router';
import { Link, RouteComponentProps } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import WhiteInosio from '../../icons/whiteinosio.svg';
import BMWHelvetica75 from '../../fonts/BMWHelvetica-Bold/BMWHelvetica-Bold.otf';
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { selectAuthState, getRegisterUser, getRecordAgreement, setGlobalError, getAddProfile } from '../../shared/sagas/auth/authSlice';
import { RightContainer } from '../../components/RightContainer';
import CheckBox from '../../icons/CheckBox.svg';
import UnCheckedBox from '../../icons/UnCheckedBox.svg';
import TermsDialog from '../../components/TermsDialog';
import { getInosioTermsAndConditions, selectOnboardingApplicationState } from '../../pmui/onboarding/sagas/pmonboardingSlice';
import { AcceptTermsandConditionsDto, AddProfileDto, UserRegistrationV2Dto } from '@inosio/payments-sdk';
import { useFormik } from 'formik';
import { InputField } from '../../components/InputController';
import { schemaValidationUser, schemaValidationUserType } from '../../utils/validation';
import { IPA_ACCESS_TOKEN_NAME } from '../../utils/constants';

type LocationState = {
  from: Location;
  token: string;
  addprofile: boolean;
  residentUuid?: string; //This is for new resident registraion flow
};

const useStyles = makeStyles(() => ({
  rootContainer: {
    height: '100vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    background: '#FFFFFF',
    borderRadius: '24px',
  },
  rightContainer: {
    background: '#053742',
    width: '59%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
  },
  leftContainer: {
    borderRadius: '24px 0px 0px 24px',
    background: '#FFFFFF',
    width: '41%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
  },
  brandContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '30px',
    width: '340px',
    marginLeft: '30px',
    padding: '20px',
  },
  brandtextContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '36px',
  },
  brandText: {
    fontFamily: `'"${BMWHelvetica75}"'`,
    fontWeight: 700,
    fontSize: '24px',
  },

  formContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: '20px',
    width: '340px',
    border: 'none',
  },
  inputBox: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 40px rgba(0, 0, 0, 0.1)',
    borderRadius: '24px',
    border: 'none',
    paddingLeft: '18px',
    width: '340px',
    height: '49px',
    fontFamily: 'Work Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '21px',
    color: '#14142B',
  },
  buttonContainer: {
    width: '340px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '20px',
  },
  wrapper: {
    margin: '1px',
    position: 'relative',
  },
  buttonProgress: {
    color: '#053742',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  pageError: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '30px',
    borderTop: '2px  solid #DB3939',
    borderRadius: '24px',
    padding: '12px 20px',
    width: '340px',
    height: '49px',
    justifyContent: 'center',
  },
  checkboxError: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '24px',
    width: '340px',
    justifyContent: 'center',
    padding: '3px',
  },
  termsAndConditionLink: {
    fontFamily: 'Work Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
    color: '#39A2DB',
    marginTop: '18px',
    cursor: 'pointer',
  },
  styleLink: {
    textDecoration: 'none',
  },
}));
export default function CompleteRegistration(props: RouteComponentProps<{}, StaticContext, LocationState>): ReactElement {
  const { location } = props;
  const navigation = useHistory();
  const dispatch = useDispatch();
  const { accountActivationDetails, isFetching, userRegistrationDetails, userRegistrationError, errorMessage, isAcceptingTerms, isAcceptedTerms, isAddProfileSuccess } =
    useSelector(selectAuthState);
  const [openInosio, setOpenInosio] = React.useState(false);
  const [termsAccepted, setTermsAccepted] = React.useState(false);
  const { contract } = useSelector(selectOnboardingApplicationState);

  const classes = useStyles();

  const initialValues: schemaValidationUserType = {
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
  };

  const formik = useFormik<schemaValidationUserType>({
    initialValues,
    validationSchema: schemaValidationUser,

    onSubmit: async (values) => {
      // prevent duplicate auth requests
      !sessionStorage.getItem(IPA_ACCESS_TOKEN_NAME) &&
        termsAccepted &&
        dispatch({
          type: getRegisterUser.type,
          payload: {
            FirstName: values.firstName,
            MiddleName: values.middleName,
            LastName: values.lastName,
            Email: values.email,
            Password: values.password,
          } as UserRegistrationV2Dto,
        });
      return;
    },
  });
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [token, setToken] = useState('');
  const [residentUuid, setResidentUuid] = useState('');
  const [userEntityType, setUserEntityType] = useState('');
  const [pageError, setPageError] = useState('');
  const [checkBoxErrorText, setCheckBoxErrorText] = useState('');

  useEffect(() => {
    if (accountActivationDetails) {
      formik.setFieldValue('email', accountActivationDetails?.Email || '');
      formik.setFieldValue('firstName', accountActivationDetails?.FirstName || '');
      formik.setFieldValue('middleName', accountActivationDetails?.MiddleName || '');
      formik.setFieldValue('lastName', accountActivationDetails?.LastName || '');
      setUserEntityType(accountActivationDetails.EntityType.toLowerCase());
    }
  }, [accountActivationDetails]);

  useEffect(() => {
    if (formik.isValid) setDisableSubmit(false);
  }, [formik.isValid, disableSubmit]);

  useEffect(() => {
    if (Object.keys(location.state).length !== 0) {
      setToken(location.state.token);

      if (location.state.residentUuid) {
        //This is for new resident registraion flow
        setResidentUuid(location.state.residentUuid);
      }
    }
  }, [token, location.state]);

  //once user registration successful, accept terms and conditions
  useEffect(() => {
    if (isFetching) setDisableSubmit(true);
    if (userRegistrationDetails && Object.keys(userRegistrationDetails).length !== 0) {
      if (userRegistrationDetails.status === 'Success') {
        dispatch({
          type: getRecordAgreement.type,
          payload: {
            Version: contract.InosioTsCs.Version,
            Description: contract.InosioTsCs.Description,
          } as AcceptTermsandConditionsDto,
        });
      }
    }
  }, [userRegistrationDetails, dispatch]);

  //once terms and conditions accepted, assign a profile to the new user
  useEffect(() => {
    if (isAcceptedTerms) {
      if (userRegistrationDetails && Object.keys(userRegistrationDetails).length !== 0) {
        if (userRegistrationDetails.status === 'Success') {
          dispatch({
            type: getAddProfile.type,
            payload: {
              ActivationToken: token,
            } as AddProfileDto,
          });
        }
      }
    }
  }, [isAcceptedTerms]);

  //error handling
  useEffect(() => {
    if (userRegistrationError && Object.keys(userRegistrationError).length !== 0) {
      if (userRegistrationError?.statusCode === 409) {
        dispatch(setGlobalError({ message: 'This email address is already registered.' }));

        setDisableSubmit(false);
        navigation.push({
          pathname: '/userlogin',
          state: {
            token,
            residentUuid,
            email: formik.values.email,
          },
        });
      } else if (userRegistrationError?.statusCode >= 400 && userRegistrationError?.statusCode< 500) {
        setDisableSubmit(false);
        setPageError(userRegistrationError?.message);
      } else {
        setDisableSubmit(false);
        setPageError('Something went wrong');
      }
    }
  }, [userRegistrationError, disableSubmit, isFetching]);

  useEffect(() => {
    if (errorMessage) {
      setPageError(errorMessage);
    }
  }, [errorMessage]);

  const matches900 = useMediaQuery('(max-width:900px)');
  const matches1200 = useMediaQuery('(max-width:1200px)');

  const handleCloseInosio = () => {
    setOpenInosio(false);
    setTermsAccepted(true);
  };

  //Fetching terms and conditions text
  useEffect(() => {
    if (!contract.InosioTsCs.Text) {
      dispatch({
        type: getInosioTermsAndConditions.type,
      });
    }
  }, [dispatch, token, residentUuid]);

  const checkBoxErrorMethod = () => {
    if (!termsAccepted) {
      setCheckBoxErrorText('Please agree to the terms and conditions before proceeding');
    } else {
      setCheckBoxErrorText('');
    }
  };

  //once assigning a profile is successful, navigate to the appropriate portal
  useEffect(() => {
    if (isAddProfileSuccess) {
      if (userEntityType === 'resident') navigation.push('/resui');
      else if (userEntityType === 'propertymanager' || userEntityType === 'vendoruser') navigation.push('/pmui');
      else navigation.push('/');
    }
  }, [dispatch, isAddProfileSuccess]);

  return (
    <div className={classes.rootContainer}>
      <Grid sx={{ flexDirection: 'column' }} className={classes.leftContainer}>
        <div className={classes.leftContainer}>
          {pageError.length ? (
            <div className={classes.pageError}>
              <Typography
                style={{
                  fontFamily: 'BMWHelvetica',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  fontSize: '14px',
                  lineHeight: '18px',
                  color: '#DB3939',
                }}
              >
                {' '}
                {pageError}
              </Typography>
            </div>
          ) : (
            <></>
          )}

          <div className={classes.brandContainer}>
            <div>
              <img src={WhiteInosio} style={{ width: '130px', height: '130px' }} alt="logo" />
            </div>
            <div className={classes.brandtextContainer}>
              <Typography sx={{ fontFamily: 'BMWHelveticaBold', fontWeight: '700', fontSize: '24px', fontStyle: 'normal', lineHeight: '30px', color: '#14142B' }}>
                Welcome to
                <br /> {accountActivationDetails && Object.keys(accountActivationDetails).length !== 0 ? accountActivationDetails?.CompanyDbaName : ''}
              </Typography>
            </div>
          </div>

          <Box component="form" onSubmit={formik.handleSubmit} noValidate className={classes.formContainer}>
            <InputField
              name={'firstName'}
              label={'First name'}
              value={formik.values.firstName}
              isError={false}
              errors={formik.errors?.firstName}
              touched={formik.touched?.firstName}
              onBlur={formik.handleBlur}
              onChange={(e) => formik.setFieldValue('firstName', e.target.value)}
            />
            <InputField
              name={'middleName'}
              label={'Middle name'}
              value={formik.values.middleName}
              isError={false}
              errors={formik.errors?.middleName}
              touched={formik.touched?.middleName}
              onBlur={formik.handleBlur}
              onChange={(e) => formik.setFieldValue('middleName', e.target.value)}
            />
            <InputField
              name={'lastName'}
              label={'Last name'}
              value={formik.values.lastName}
              isError={false}
              errors={formik.errors?.lastName}
              touched={formik.touched?.lastName}
              onBlur={formik.handleBlur}
              onChange={(e) => formik.setFieldValue('lastName', e.target.value)}
            />
            <InputField
              name={'email'}
              placeholder={'Email'}
              label={'Email'}
              value={formik.values.email}
              isError={false}
              errors={formik.errors?.email}
              touched={formik.touched?.email}
              onBlur={formik.handleBlur}
              onChange={(e) => formik.setFieldValue('email', e.target.value)}
            />
            <InputField
              name={'password'}
              placeholder={'Password'}
              type="password"
              label={'Password'}
              isError={false}
              errors={formik.errors?.password}
              touched={formik.touched?.password}
              onBlur={formik.handleBlur}
              onChange={(e) => formik.setFieldValue('password', e.target.value)}
            />
            <InputField
              name={'confirmPassword'}
              type="password"
              label={'Confirm-password'}
              isError={false}
              errors={formik.errors?.confirmPassword}
              touched={formik.touched?.confirmPassword}
              onBlur={formik.handleBlur}
              onChange={(e) => formik.setFieldValue('confirmPassword', e.target.value)}
            />
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Typography
                style={{
                  fontFamily: 'Work Sans',
                  paddingLeft: '18px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '16px',
                  lineHeight: '22px',
                  marginTop: '10px',
                }}
              >
                Accept{' '}
                <span
                  style={{
                    cursor: 'pointer',
                  }}
                  className={classes.termsAndConditionLink}
                  onClick={() => {
                    setOpenInosio(true);
                  }}
                >
                  T&Cs
                </span>
              </Typography>
              <Grid ml={1} mt={1.3} item sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <img
                  id="accept-terms"
                  src={termsAccepted ? CheckBox : UnCheckedBox}
                  style={{ width: '13px', height: '13px', cursor: 'pointer' }}
                  alt="Checkmark"
                  onClick={() => setTermsAccepted(!termsAccepted)}
                />
              </Grid>
            </Grid>
            {checkBoxErrorText.length ? (
              <div className={classes.checkboxError}>
                <Typography
                  style={{
                    fontFamily: 'BMWHelvetica',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '18px',
                    color: '#DB3939',
                  }}
                >
                  {' '}
                  {checkBoxErrorText}
                </Typography>
              </div>
            ) : (
              <></>
            )}
            <div className={classes.buttonContainer}>
              <div className={classes.wrapper}>
                <Link
                  className={classes.styleLink}
                  to={{
                    pathname: '/userlogin',
                    state: {
                      token,
                      residentUuid,
                    },
                  }}
                >
                  <Button
                    disabled={disableSubmit || isFetching}
                    variant="outlined"
                    sx={{
                      width: '183px',
                      height: '49px',
                      borderRadius: '24px',
                      textTransform: 'none',
                      color: '#39A2DB',
                      transition: 'background 0.55s, color 0.55s',
                      borderColor: '#39A2DB',
                      '&:hover': {
                        backgroundColor: '#39A2DB',
                        color: 'white',
                        borderColor: '#39A2DB',
                      },
                    }}
                  >
                    I have an account
                  </Button>
                </Link>
              </div>
              <div className={classes.wrapper}>
                <Button
                  type="submit"
                  variant="contained"
                  style={{
                    width: '113px',
                    height: '49px',
                    borderRadius: '24px',
                    textTransform: 'capitalize',
                    color: 'white',
                    backgroundColor: '#39A2DB',
                    borderColor: '#39A2DB',
                  }}
                  onClick={checkBoxErrorMethod}
                  id="Sign-Up"
                >
                  Sign Up
                </Button>
                {isFetching || isAcceptingTerms ? <CircularProgress size={26} className={classes.buttonProgress} /> : <></>}
              </div>
            </div>
          </Box>
        </div>
        <TermsDialog open={openInosio} scroll={true} text={contract.InosioTsCs.Text} title="Inosio Agreement" handleConfirm={handleCloseInosio} buttonText="Agree" />
      </Grid>

      {!(matches900 && matches1200) ? (
        <Grid className={classes.rightContainer}>
          <RightContainer />
        </Grid>
      ) : (
        <></>
      )}
    </div>
  );
}
